import { render } from "./userinfo.vue?vue&type=template&id=b128b5f0&scoped=true&ts=true"
import script from "./userinfo.vue?vue&type=script&lang=ts"
export * from "./userinfo.vue?vue&type=script&lang=ts"

import "./userinfo.vue?vue&type=style&index=0&id=b128b5f0&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b128b5f0"]])

export default __exports__